import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import { Dropdown, Checkbox, Button, Icon } from 'semantic-ui-react';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { clone } from '../../../../reducers/helper.js';
import { updateWaitingAreaLocalAccessHoursForm } from '../../../../actions/waitingArea.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import {
  timeOptionStart,
  timeOptionEnd,
  serviceOfferingAvailabilityTemplate,
  getTimeOptionEnd,
} from '../../../../businessLogic/operatingDaysAndHours';
import { debug } from 'util';

export default function CenterPanelUpdate(props) {
  const dispatch = useDispatch();
  const localAccessHoursUpdated = (property, value, index) => {
    let localAccessHoursForm = clone(props.waitingAreaLocalAccessHoursForm);
    localAccessHoursForm.serviceOfferingAvailabilities[index][property] = value;
    dispatch(updateWaitingAreaLocalAccessHoursForm(localAccessHoursForm));
  };

  const localAccessHoursDayChanged = (value, dayNumber, index) => {
    switch (dayNumber) {
      case 0:
        localAccessHoursUpdated('isMondaySelected', value, index);
        break;
      case 1:
        localAccessHoursUpdated('isTuesdaySelected', value, index);
        break;
      case 2:
        localAccessHoursUpdated('isWednesdaySelected', value, index);
        break;
      case 3:
        localAccessHoursUpdated('isThursdaySelected', value, index);
        break;
      case 4:
        localAccessHoursUpdated('isFridaySelected', value, index);
        break;
      case 5:
        localAccessHoursUpdated('isSaturdaySelected', value, index);
        break;
      case 6:
        localAccessHoursUpdated('isSundaySelected', value, index);
        break;
    }
  };

  const fromTimeChange = (e, v, index) => {
    let LocalAccessHoursForm = clone(props.waitingAreaLocalAccessHoursForm);

    const endTimeValue = LocalAccessHoursForm.serviceOfferingAvailabilities[index].toTime;
    let startTimeIndex = timeOptionStart.findIndex((x) => {
      return x.value == v.value;
    });
    let endTimeIndex = timeOptionEnd.findIndex((x) => {
      return x.value == endTimeValue;
    });

    if (endTimeIndex < startTimeIndex) {
      LocalAccessHoursForm.serviceOfferingAvailabilities[index].toTime = timeOptionEnd[startTimeIndex].value;
    }

    LocalAccessHoursForm.serviceOfferingAvailabilities[index].fromTime = v.value;
    // timeOptionEnd
    dispatch(updateWaitingAreaLocalAccessHoursForm(LocalAccessHoursForm));
  };

  const limitedByLocalTimeChange = (e, v) => {
    let LocalAccessHoursForm = clone(props.waitingAreaLocalAccessHoursForm);
    LocalAccessHoursForm.limitedByLocalTime = v.checked;
    dispatch(updateWaitingAreaLocalAccessHoursForm(LocalAccessHoursForm));
  };

  const toTimeChange = (e, v, index) => {
    let LocalAccessHoursForm = clone(props.waitingAreaLocalAccessHoursForm);
    LocalAccessHoursForm.serviceOfferingAvailabilities[index].toTime = v.value;
    dispatch(updateWaitingAreaLocalAccessHoursForm(LocalAccessHoursForm));
  };

  const addNewSeviceAvailability = () => {
    if (props.waitingAreaLocalAccessHoursForm.limitedByLocalTime) {
      let LocalAccessHoursForm = clone(props.waitingAreaLocalAccessHoursForm);
      LocalAccessHoursForm.serviceOfferingAvailabilities.push(serviceOfferingAvailabilityTemplate);
      dispatch(updateWaitingAreaLocalAccessHoursForm(LocalAccessHoursForm));
    }
  };
  const removeAvailibilty = (index) => {
    if (props.waitingAreaLocalAccessHoursForm.limitedByLocalTime) {
      let LocalAccessHoursForm = clone(props.waitingAreaLocalAccessHoursForm);
      LocalAccessHoursForm.serviceOfferingAvailabilities.splice(index, 1);
      dispatch(updateWaitingAreaLocalAccessHoursForm(LocalAccessHoursForm));
    }
  };

  let serviceAvilability = props.waitingAreaLocalAccessHoursForm.serviceOfferingAvailabilities.map(
    (soAvailibilty, i) => {
      return (
        <div>
          <div className="available-time-area pdbxxs">
            <div className=" fl time-area">
              <div className="time-slots fl mrbxs mrtxs">
                <div className=" mrlxs  hide-on-tablet-ress hide-on-small-ress">
                  {APP.LANGUAGE.WaitingAreaLocalAccessHours.timeFrom}
                </div>
                <Txt
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  className="small-dropdown mrlxs"
                  text="text"
                  value="value"
                  extraParam={i}
                  semanticui
                  normal
                  noSearch={true}
                  dropdown
                  selectedValue={soAvailibilty.fromTime}
                  options={timeOptionStart}
                  onChange={fromTimeChange}
                />
                <div className=" mrrxs mrlxs  hide-on-small-ress">
                  {APP.LANGUAGE.WaitingAreaLocalAccessHours.timeTo}
                </div>
                <div className=" mrrxs mrlxs  show-on-small-ress text-size-mms">
                  {APP.LANGUAGE.WaitingAreaLocalAccessHours.timeTo}
                </div>
                <Txt
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  className="small-dropdown"
                  text="text"
                  value="value"
                  semanticui
                  normal
                  dropdown
                  noSearch={true}
                  selectedValue={soAvailibilty.toTime}
                  extraParam={i}
                  options={getTimeOptionEnd(soAvailibilty.fromTime)}
                  onChange={toTimeChange}
                />
              </div>
              <div className="fr pdrxs pdtxs  hide-on-tablet-ress hide-on-small-ress " data-show={i > 0}>
                <Button
                  onClick={() => {
                    removeAvailibilty(i);
                  }}
                  icon
                  className="color-bad-things circular super-mini "
                >
                  <Icon name="remove" className="icon color-white" />{' '}
                </Button>
              </div>
              <div
                className={
                  props.waitingAreaLocalAccessHoursForm.limitedByLocalTime
                    ? 'fr pdrxs  pdtxs show-on-tablet-ress '
                    : 'fr pdrxs  pdtxs show-on-tablet-ress disable'
                }
                data-show={i > 0}
              >
                <Button
                  onClick={() => {
                    removeAvailibilty(i);
                  }}
                  icon
                  className="color-bad-things circular super-mini "
                >
                  <Icon name="remove" className="icon color-white" />{' '}
                </Button>
              </div>
              <div
                className={
                  props.waitingAreaLocalAccessHoursForm.limitedByLocalTime
                    ? 'fr pdrxs  pdtxs show-on-small-ress '
                    : 'fr pdrxs  pdtxs show-on-small-ress disable'
                }
                data-show={i > 0}
              >
                <Button
                  onClick={() => {
                    removeAvailibilty(i);
                  }}
                  icon
                  className="color-bad-things circular super-mini "
                >
                  <Icon name="remove" className="icon color-white" />{' '}
                </Button>
              </div>
            </div>
            <div className="pdlxs">
              <div className="  show-on-desktop-ress ">
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.MondayText}
                  className="weekDayCheckBox weekDayCheckBoxSmall"
                  checked={soAvailibilty.isMondaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 0, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.TuesdayText}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isTuesdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 1, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.WednesdayText}
                  className="weekDayCheckBox mrrml"
                  checked={soAvailibilty.isWednesdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 2, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.ThursdayText}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isThursdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 3, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.FridayText}
                  className="weekDayCheckBox weekDayCheckBoxSmall"
                  checked={soAvailibilty.isFridaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 4, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.SaturdayText}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isSaturdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 5, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.SundayText}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isSundaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 6, i);
                  }}
                />
              </div>

              <div className=" show-on-tablet-ress">
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.MondayShort}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isMondaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 0, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.TuesdayShort}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isTuesdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 1, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.WednesdayShort}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isWednesdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 2, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.ThursdayShort}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isThursdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 3, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.FridayShort}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isFridaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 4, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.SaturdayShort}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isSaturdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 5, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.SundayShort}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isSundaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 6, i);
                  }}
                />
              </div>
              <div className=" show-on-small-ress">
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.MondayMini}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isMondaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 0, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.TuesdayMini}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isTuesdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 1, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.WednesdayMini}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isWednesdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 2, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.ThursdayMini}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isThursdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 3, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.FridayMini}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isFridaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 4, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.SaturdayMini}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isSaturdaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 5, i);
                  }}
                />
                <Checkbox
                  disabled={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
                  label={APP.LANGUAGE.WaitingAreaLocalAccessHours.SundayMini}
                  className="weekDayCheckBox"
                  checked={soAvailibilty.isSundaySelected}
                  onChange={(e, v) => {
                    localAccessHoursDayChanged(v.checked, 6, i);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="mrbs" />
        </div>
      );
    }
  );
  return (
    <span>
      <div className="ui form">
        <Checkbox
          className="weekDayCheckBox checkboxlargeWidth mrbs localAccessCheckBox"
          label={APP.LANGUAGE.WaitingAreaLocalAccessHours.WaitingAreaLocalAccessAvailabilityUpdate}
          onChange={limitedByLocalTimeChange}
          checked={props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}
        />

        <div className={props.waitingAreaLocalAccessHoursForm.limitedByLocalTime ? '' : 'localAccessHours disable'}>
          {serviceAvilability}
          <div
            className={
              props.waitingAreaLocalAccessHoursForm.limitedByLocalTime
                ? 'show-on-desktop-ress'
                : 'show-on-desktop-ress disable'
            }
          >
            <Button className="tiny circular " icon onClick={addNewSeviceAvailability}>
              <Icon name="plus" />
            </Button>{' '}
            <span className="pdlxs">Add another time</span>
          </div>
          <div
            className={
              props.waitingAreaLocalAccessHoursForm.limitedByLocalTime
                ? 'show-on-tablet-ress'
                : 'show-on-tablet-ress disable'
            }
          >
            <Button className="tiny circular " icon onClick={addNewSeviceAvailability}>
              <Icon name="plus" />
            </Button>
            <span className="pdlxs">Add another time</span>
          </div>
          <div
            className={
              props.waitingAreaLocalAccessHoursForm.limitedByLocalTime
                ? 'show-on-small-ress'
                : 'show-on-small-ress disable'
            }
          >
            <Button className="tiny circular " icon onClick={addNewSeviceAvailability}>
              <Icon name="plus" />
            </Button>
            <span className="pdlxs">Add another time</span>
          </div>
        </div>
      </div>
    </span>
  );
}
